export const isUndefined = (thing: any): thing is undefined => typeof thing === 'undefined';

export const isFunction = (thing: any): thing is Function => typeof thing === 'function';